<template>
  <div>
    <hero-bar>
      Address
    </hero-bar>
    <div class="columns">
      <div class="column is-one-quarter" style="margin:2%;margin-top:2%;">
        <div class="columns is-mobile is-multiline" style="margin-bottom:5%;">
          <!--<b-select style="width:95%" placeholder="Select client" @input=onChangeClient($event) v-model="client">
            <option v-for="(client, index) in clientsMainAccount" :key="index" :value="client.clientCode">
              {{ client.clientName + ' (' + client.clientCode + ')' }}
            </option>
          </b-select>-->
        </div>

        <div class="column is-one-half" style="margin:2%;margin-top:2%;">
          <b-field label="Find address">
            <b-autocomplete
              v-model="name"
              :data="filteredAddresses"
              placeholder=""
              :loading="isFetching"
              @select="option => selected"
            >
            </b-autocomplete>
          </b-field>
        </div>

        <div class="column is-one-half" style="margin:2%;margin-top:2%;">
          <div class="control">
            <b-button @click="editAddress">Edit Address</b-button>
          </div>
        </div>

        <div class="column is-one-half" style="margin:2%;margin-top:2%;">
          <div class="control">
            <b-button @click="addAddress">New Address</b-button>
          </div>
        </div>
      </div>
      <div class="column is-8">
        <section class="section is-main-section">
          <form @submit.prevent="submit">
            <div v-if="errors.length" class="column is-one-third">
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>
            <div class="columns is-mobile is-multiline">
              <div class="column is-one-fifth">
                <b-field label="Address Name">
                  <b-input
                    v-model="addressName"
                    id="addressName"
                    :disabled="isDisabled"
                    required
                    @blur="checkForm"
                  />
                </b-field>
              </div>
            </div>
            <div class="columns is-mobile is-multiline">
              <div class="column is-half">
                <b-field label="Street Address">
                  <b-input
                    v-model="address"
                    id="address"
                    required
                    @blur="checkForm"
                  />
                </b-field>
              </div>
            </div>
            <div class="columns is-mobile is-multiline">
              <div class="column is-one-fifth">
                <b-field label="Suburb">
                  <b-input
                    v-model="town"
                    id="town"
                    required
                    @blur="checkForm"
                  />
                </b-field>
              </div>
              <div class="column is-one-fifth">
                <b-field label="Postcode">
                  <b-input
                    v-model="postcode"
                    id="postcode"
                    required
                    @blur="checkForm"
                  />
                </b-field>
              </div>
            </div>
            <div class="columns is-mobile is-multiline">
              <div class="column is-one-fifth">
                <b-field label="GPS">
                  <b-input v-model="gps" id="gps" required @blur="checkForm" />
                </b-field>
              </div>
            </div>
            <div class="columns is-mobile is-multiline">
              <div class="column is-one-fifth">
                <b-field label="PIC">
                  <b-input v-model="pic" id="pic" required @blur="checkForm" />
                </b-field>
              </div>
            </div>
            <hr />
            <div class="control">
              <b-button
                v-if="isSaveEnabled"
                native-type="submit"
                type="is-primary"
                >Save Address</b-button
              >
            </div>
          </form>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBar from "@/components/HeroBar";
import axios from "axios";

export default {
  name: "Forms",
  components: { HeroBar },
  props: {
    id: {
      default: null
    }
  },
  data() {
    return {
      addr: null,
      data: [],
      addresses: [],
      name: "",
      selected: null,
      isSaveEnabled: false,
      isDisabled: true,
      errors: [],
      pic: null,
      isFetching: false,
      town: null,
      postcode: null,
      address: null,
      suburb: null,
      addressName: null,
      gps: null
    };
  },
  computed: {
    filteredAddresses() {
      return this.addresses.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.name.toLowerCase()) >= 0
        );
      });
    }
  },
  methods: {
    editAddress() {
      this.getAddress(this.name);
      this.isDisabled = true;
    },
    addAddress() {
      this.clearForm();
      this.isDisabled = false;
      this.isFetching = false;
    },
    clearForm() {
      this.addressName = null;
      this.address = null;
      this.town = null;
      this.postcode = null;
      this.pic = null;
      this.gps = null;
    },
    submit(e) {
      var errorFound = false;

      this.isLoading = true;

      this.errors = [];

      if (this.addressName.length < 3) {
        this.errors.push("Name must be greater than 3 characters.");
        errorFound = true;
      }

      if (!this.isDisabled) {
        var x = "";
        var current = false;
        for (x in this.addresses) {
          if (this.addressName === this.addresses[x].addressName) {
            current = true;
          }
        }

        if (current) {
          this.errors.push("This address name already exists.");
          errorFound = true;
        }
      }

      if (this.errors.length > 0) {
        return true;
      }

      e.preventDefault();

      if (!errorFound) {
        if (this.saveAddress()) {
          setTimeout(() => {
            this.isLoading = false;
            this.$buefy.snackbar.open({
              message: "Address has been saved",
              queue: false
            });
          }, 500);
        }
      }
    },
    checkForm() {
      var missingData = false;
      if (document.getElementById("addressName").value === "") {
        missingData = true;
      }
      if (document.getElementById("address").value === "") {
        missingData = true;
      }
      if (document.getElementById("town").value === "") {
        missingData = true;
      }
      if (document.getElementById("postcode").value === "") {
        missingData = true;
      }
      if (document.getElementById("pic").value === "") {
        missingData = true;
      }
      if (document.getElementById("gps").value === "") {
        missingData = true;
      }

      if (!missingData) {
        this.isSaveEnabled = true;
      } else {
        this.isSaveEnabled = false;
      }
    },
    async saveAddress() {
      if (!this.isDisabled) {
        this.postAddress();
      } else {
        this.putAddress();
      }
      this.addresses = [];
      this.addr = null;
      this.getAddresses();
      this.isDisabled = true;
      this.selected = "";
    },
    async putAddress() {
      try {
        await axios.put(
          this.$store.state.apiUrl + "lookup/address/" + this.addressName,
          {
            address: this.address,
            town: this.town,
            postcode: this.postcode,
            gps: this.gps,
            pic: this.pic
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async postAddress() {
      try {
        await axios.post(
          this.$store.state.apiUrl + "lookup/address/",
          {
            addressName: this.addressName,
            address: this.address,
            town: this.town,
            postcode: this.postcode,
            gps: this.gps,
            pic: this.pic
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async getAddress(addressName) {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "lookup/address/" + addressName,
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );

        this.address = data[0].address;
        this.addressName = data[0].addressName;
        this.town = data[0].town;
        this.postcode = data[0].postcode;
        this.pic = data[0].pic;
        this.gps = data[0].gps;
      } catch (error) {
        console.log(error);
      }
    },
    async getAddresses() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "lookup/address",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        // this.addresses = data
        var i = 0;
        for (i = 0; i < data.length; i++) {
          this.addresses.push(data[i].addressName);
        }
        this.addresses.sort();
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.getAddresses();
  }
};
</script>
